import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { checkToken, closeLoginPopup } from "../../../redux/actions";
import lockIcon from '../../../images/lock.svg';
import loaderIcon from '../../../images/loader.svg';
import style from './login-popup.module.scss';
import { getPoints } from "../../../utils/getPoints";

export const LoginPopup = () => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const langName = useSelector(state => state.app.currentLangName)
    const savedToken = useSelector(state => state.app.token)
    const id = useSelector(state => state.user.id)
    const loginPopup = useSelector(state => state.app.loginPopup)
    const codePopupLoading = useSelector(state => state.app.codePopupLoading)
    const gifts = useSelector(state => state.game.gameShop?.gifts);
    const playPrice = useSelector(state => state.game.gameWheel?.settings?.playPrice);
    const [token, setToken] = useState('');

    useEffect(() => {
        setToken(savedToken)
    }, [savedToken])

    function close() {
        dispatch(closeLoginPopup())
    }

    if (!loginPopup) return (null);
    let minPrice = 0;
    if (Array.isArray(gifts) && gifts.length > 0) {
        minPrice = Number(gifts[0].price);
        for (let i = 0; i < gifts.length; i++) {
            const giftPrice = Number(gifts[i].price);
            if (minPrice > giftPrice) minPrice = giftPrice;
        }
    }
    if(playPrice && isNaN(playPrice) && minPrice > playPrice) minPrice = Number(playPrice);

    else return (
        <div className="codePopup">
            <div className="codePopup__back" onClick={() => close()}></div>
            <div className="codePopup__wrap">
                <div className="codePopup__box">
                    <div className="codePopup__head">
                        {lang.shop.popup.title}
                        <div className="codePopup__close" onClick={() => close()}>
                        </div>
                    </div>
                    <div className="codePopup__body">
                        <div className={style['login-popup']}>
                            <img className={style['login-popup__img']} src={lockIcon} alt="" />
                            <div className={style['login-popup__text']}
                            dangerouslySetInnerHTML={{ __html: lang.shop.popup.text1 + " " + minPrice + ' ' + getPoints(langName, minPrice, 1)+ lang.shop.popup.text2 }} />
                            <form className={style['login-popup__row']} onSubmit={(event) => { event.preventDefault(); dispatch(checkToken(id, token)); }}>
                                <input onChange={(event) => { setToken(event.target.value) }} className={style['login-popup__input']} type="text" value={token} />
                                <button className={style['login-popup__button']}>
                                    {
                                        codePopupLoading
                                            ? <img src={loaderIcon} alt="loader" />
                                            : <div className={style['login-popup__button-icon']}/>
                                    }
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}